import {KeySvg} from './KeySvg';
import {MapSvg} from './MapSvg';
import {AddSvg} from './AddSvg';
import {TagSvg} from './TagSvg';
import {CopySvg} from './CopySvg';
import {GiftSvg} from './GiftSvg';
import {PlusSvg} from './PlusSvg';
import {MailSvg} from './MailSvg';
import {UserSvg} from './UserSvg';
import {HeartSvg} from './HeartSvg';
import {PhoneSvg} from './PhoneSvg';
import {CheckSvg} from './CheckSvg';
import {MinusSvg} from './MinusSvg';
import {RemoveSvg} from './RemoveSvg';
import {FilterSvg} from './FilterSvg';
import {CameraSvg} from './CameraSvg';
import {GoogleSvg} from './GoogleSvg';
import {GoBackSvg} from './GoBackSvg';
import {SearchSvg} from './SearchSvg';
import {BasketSvg} from './BasketSvg';
import {EyeOffSvg} from './EyeOffSvg';
import {TwitterSvg} from './TwitterSvg';
import {ViewAllSvg} from './ViewAllSvg';
import {HeartBigSvg} from './HeartBigSvg';
import {FaceBookSvg} from './FaceBookSvg';
import {BellTabSvg} from './tabs/BellTabSvg';
import {RightArrowSvg} from './RightArrowSvg';
import {StatusCheckSvg} from './StatusCheckSvg';
import {HeaderBasketSvg} from './HeaderBasketSvg';
import {RememberCheckSvg} from './RememberCheckSvg';
import {NotificationCheckSvg} from './NotificationCheckSvg';

import {ProfileSvg} from './tabs/ProfileSvg';
import {HomeTabSvg} from './tabs/HomeTabSvg';
import {HeartTabSvg} from './tabs/HeartTabSvg';
import {OrderTabSvg} from './tabs/OrderTabSvg';
import {SearchTabSvg} from './tabs/SearchTabSvg';
import { WalletSvg } from './tabs/WalletSvg';
import { DiamondSvg } from './tabs/DiamondSvg';
import { TrophySvg } from './tabs/TrophySvg';
import { DownloadSvg } from './DownloadSvg';

export const svg = {
  KeySvg,
  MapSvg,
  AddSvg,
  TagSvg,
  GiftSvg,
  UserSvg,
  PlusSvg,
  MailSvg,
  CopySvg,
  HeartSvg,
  MinusSvg,
  CheckSvg,
  PhoneSvg,
  SearchSvg,
  FilterSvg,
  BasketSvg,
  RemoveSvg,
  GoogleSvg,
  CameraSvg,
  EyeOffSvg,
  GoBackSvg,
  ViewAllSvg,
  HomeTabSvg,
  TwitterSvg,
  ProfileSvg,
  BellTabSvg,
  FaceBookSvg,
  OrderTabSvg,
  HeartTabSvg,
  HeartBigSvg,
  SearchTabSvg,
  RightArrowSvg,
  StatusCheckSvg,
  HeaderBasketSvg,
  RememberCheckSvg,
  NotificationCheckSvg,
  WalletSvg,
  DiamondSvg,
  TrophySvg,
  DownloadSvg
};
